import { Col, Row } from "antd";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import Container from "shared/components/Container";
import Form from "shared/components/Form";
import Header from "shared/components/Header";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { bindInputProps } from "utils/helpers";
import validation from "./validation";
import { useLocation } from "react-router-dom";
import Select from "shared/components/Select";
import graphql from "utils/api/graphql";
import { ADDRESS_TYPES } from "utils/constants";

const Create = ({ onSubmit, cancel }) => {
  const { state } = useLocation();
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.ADDRESS);
  const CREATE = t("CREATE", { returnObjects: true });
  const FORM = CREATE.FORM;
  return (
    <Container>
      <Formik
        initialValues={{
          organization: { id: state.organization.id },
          type: ADDRESS_TYPES.RECEIVE,
        }}
        onSubmit={onSubmit}
        validationSchema={validation(
          t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true })
        )}
      >
        {({ isValid, handleSubmit, setFieldValue, values, ...formProps }) => [
          <Header
            key={"header"}
            title={CREATE.HEADER.TITLE}
            subtitle={CREATE.HEADER.ACTION}
            actions={[
              {
                text: CREATE.HEADER.DISCARD,
                onClick: cancel,
                variant: "outlined",
              },
              {
                text: CREATE.HEADER.SAVE,
                onClick: handleSubmit,
              },
            ]}
          />,
          <Row gutter={[32]} key="form">
            <Col
              xs={{ span: 24, order: 1 }}
              sm={{ span: 24, order: 1 }}
              md={{ span: 20, offset: 2, order: 1 }}
              lg={{ span: 14, offset: 5, order: 2 }}
            >
              <div className="inputs--container">
                <div className="inputs--container__header">
                  <span>{FORM.GENERAL_INFO.TITLE}</span>
                </div>
                <Form type={"vertical"}>
                  <div className="field--item">
                    <Input
                      placeholder={FORM.GENERAL_INFO.FIELDS.VALUE}
                      {...bindInputProps({
                        name: "value",
                        values,
                        ...formProps,
                      })}
                    />
                  </div>
                  <div className="field--item">
                    <Select
                      type="async"
                      node={[
                        graphql.queries.TOKENS,
                        {
                          variables: { where: { chain: "fiat" } },
                        },
                        "tokens.data",
                      ]}
                      placeholder={FORM.GENERAL_INFO.FIELDS.VALUE}
                      {...bindInputProps({
                        name: "token",
                        values,
                        ...formProps,
                      })}
                      format={(token) => token.type}
                    />
                  </div>
                  <div className="field--item">
                    <Input
                      placeholder={FORM.GENERAL_INFO.FIELDS.VALUE}
                      disabled
                      value={state.organization.name}
                    />
                  </div>
                </Form>
              </div>
            </Col>
          </Row>,
        ]}
      </Formik>
    </Container>
  );
};

export default Create;
